import {Injectable} from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class ErrorLoggingService {
  /**
   * Envia erro para o Sentry com título e contexto
   * @param title Título do erro
   * @param error Objeto de erro ou mensagem
   * @param extra Dados adicionais de contexto
   */
  logError(
    title: string,
    error: unknown,
    extra: Record<string, any> = {},
  ): void {
    let errInstance: Error;

    if (error instanceof Error) {
      errInstance = error;
    } else if (typeof error === 'string') {
      errInstance = new Error(error);
    } else {
      errInstance = new Error(JSON.stringify(error));
    }

    // Define o nome do erro (título)
    errInstance.name = title;

    const isLocalhost =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === '::1');

    if (isLocalhost) {
      console.warn(`[Sentry Ignorado em Localhost] ${title}:`, {error, extra});
      return;
    }

    Sentry.captureException(errInstance, {
      extra,
    });
  }
}
